import React, { memo, useCallback, MouseEvent } from 'react';

import { convertDigitToProperFormat } from 'utils/number';

import { Container, Cell, Date } from './styles';
import Icon from 'components/Icon';
import { languageDirection } from '../../i18n';

type ComponentProps = {
  year: number;
  onChange: (newYear: number) => void;
};

const YearPicker: React.FC<ComponentProps> = ({ year, onChange }) => {
  const changeYear = (e: MouseEvent<HTMLElement>) => {
    const type = e.currentTarget!.dataset.type;
    const value = type === 'previous' ? -1 : 1;
    onChange(year + value);
  };
  const handleChange = useCallback(changeYear, [onChange, year]);
  const dir = languageDirection();
  return (
    <Container>
      <Cell onClick={handleChange} data-type="previous">
        {dir === 'rtl' ? (
          <Icon type="chevron-right" />
        ) : (
          <Icon type="chevron-left" />
        )}
      </Cell>
      <Date>{convertDigitToProperFormat(year)}</Date>
      <Cell onClick={handleChange} data-type="next">
        {dir === 'rtl' ? (
          <Icon type="chevron-left" />
        ) : (
          <Icon type="chevron-right" />
        )}
      </Cell>
    </Container>
  );
};

export default memo(YearPicker);
